import React from 'react';

export const BtnSimple = props => {
  const {
    onClick,
    children,
    className,
    disabled,
    color,
    border,
    sm,
    ...rest
  } = props;
  const sizeClass = sm ? 'px-05 py-03 text-xs' : 'px-1 py-05 text-sm';
  return (
    <button
      disabled={disabled}
      className={`rounded bg-${color ? color : 'primary'} ${sizeClass} border-${
        color ? color : 'primary'
      } shadow font-bold uppercasefont-condensed disabled:opacity-50 disabled:bg-transparent disabled:border-2 disabled:border-contrast border-2 ${className}`}
      onClick={event => {
        if (typeof onClick === 'function') {
          onClick(event);
        }
      }}
      {...rest}
    >
      {children}
    </button>
  );
};
